export function sortBannerByType(data = []) {
  const order = ['Fixed', 'Floating', 'Filler'];
  data.sort((x, y) => order.indexOf(x.target_type) - order.indexOf(y.target_type));
  return data;
}
